/** Повна навігація POST-формою (вхід OIDC у продуктиві: сервер відповідає 302 на сторінку постачальника). */
export function postForm(action: string): void {
  const form = document.createElement('form');
  form.method = 'post';
  form.action = action;
  form.style.display = 'none';
  document.body.appendChild(form);
  form.submit();
}
